require("./config/bootstrap")

/* PLUGINS */
import Vue from "vue"
import Vuex from "vuex"
import VueAWN from "vue-awesome-notifications"
import VeeValidate from "vee-validate"
import validationMessagesEn from "vee-validate/dist/locale/en"
import validationMessagesNo from "vee-validate/dist/locale/nb_NO"
import _ from "lodash"
import moment from "moment"
import bcrypt from "bcryptjs"
import swal from "sweetalert"
import { countryAlpha2 } from "./config/countryAlpha2"
import VueCookies from "vue-cookies"
import App from "./modules/master/components/Master.vue"

/* MIXINS */
import helpers from "./mixins/helpers"
import dropdowns from "./mixins/dropdowns"
import pageHeaderTitle from "./mixins/components/pageHeaderTitle"
import actionButton from "./mixins/components/actionButton"
import noLocale from "./mixins/components/noLocale"
import helpText from "./mixins/components/helpText"

Vue.mixin(helpers)
Vue.mixin(dropdowns)

/* CONFIGS */
import vuetify from "./config/vuetify"
import store from "./config/stores"
import router from "./config/router"
import i18n from "./config/i18n"
import { awn_notifications } from "./config/awn-notifications"
import { constants } from "./config/constants"
import "./config/registerServiceWorker"

/* STYLES */
import "vuetify/dist/vuetify.min.css"
import "vue-awesome-notifications/dist/styles/style.css"
import "./assets/css/theme.scss"
import "./assets/css/styles.scss"

// ==================================
// USE
// ==================================
Vue.use(Vuex)
Vue.use(VueAWN, awn_notifications)
Vue.use(VeeValidate, {
  classes: true,
  locale: "no",
  dictionary: {
    en: validationMessagesEn,
    no: validationMessagesNo
  }
})

Vue.set(Vue.prototype, "_", _)
Vue.set(Vue.prototype, "moment", moment)
Vue.set(Vue.prototype, "bcrypt", bcrypt)
Vue.set(Vue.prototype, "swal", swal)
Vue.set(Vue.prototype, "countryAlpha2", countryAlpha2)

Vue.use(VueCookies)
Vue.$cookies.config("1d")

// ==================================
// VEE-VALIDATE CUSTOM VALIDATION
// ==================================
VeeValidate.Validator.extend("password_strength", {
  getMessage: (field) => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number. Minimum of 8 characters.`,
  validate: (value) => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})")
    return strongRegex.test(value)
  }
})

VeeValidate.Validator.extend("no_space", {
  getMessage: (field) => `Space is not allowed.`,
  validate: (value) => {
    var bool = value.indexOf(" ") >= 0
    return !bool
  }
})

VeeValidate.Validator.extend("sizePerFileInMB", {
  getMessage: (field, args) => `Size per file should be less than ${args[0]} Mb`, 
  validate(files, args) {
    var mb = args[0]
    //var bytes = mb * 1024 * 1024
    var bytes = mb * 1000000
    console.log("sizePerFileInMB.validate()")

    if(!Array.isArray(files)) {
      let file = files
      files = []
      files.push(file)
    }

    return !files.some(file => file.size > bytes)
  }
})

VeeValidate.Validator.extend("validDate", {
  getMessage: (field) => `Invalid date. Format must be ${constants.DATE_FORMAT}`,
  validate(value) {
    let checker = moment(value, constants.DATE_FORMAT, true)
    return checker.isValid()
  }
})

VeeValidate.Validator.extend("validTime", {
  getMessage: (field) => `Invalid time. Format must be ${constants.TIME_FORMAT}`,
  validate(value) {
    let checker = moment(value, constants.TIME_FORMAT, true)
    return checker.isValid()
  }
})

// ==================================
// MIXINS
// ==================================
Vue.mixin({
  data: function() {
    return constants
  }
})

Vue.component("page-header-title", pageHeaderTitle)
Vue.component("action-button", actionButton)
Vue.component("no-locale", noLocale)
Vue.component("help-text", helpText)

// ==================================
// DISABLE VUE IN PROD
// ==================================
if (process.env.NODE_ENV == "production") {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
  Vue.config.productionTip = false
} else {
  console.log("DEVELOPMENT MODE")
}

new Vue({
  vuetify,
  i18n,
  router,
  store,
  data: {
    window: window
  },
  render: (h) => h(App)
}).$mount("#app")
